import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { Thread } from 'src/app/models/thread.model';
import { ClientcommunicationService } from 'src/app/services/clientcommunication/clientcommunication.service';
import { Observable, Subscription } from 'rxjs';
import { Room } from 'src/app/models/room.model';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FileUpload } from 'src/app/models/FileUpload';
import { MessageService } from 'primeng/api';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { AppSettings } from 'src/app/Constant/AppSettings';
declare var CKEDITOR: any;
@Component({
  selector: 'app-chat-area',
  templateUrl: './chat-area.component.html',
  styleUrls: ['./chat-area.component.css'],
  animations: [
    trigger('animation', [
      state('visible', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(50%)', opacity: 0 }),
        animate('300ms ease-out')
      ]),
      transition('* => void', [
        animate(('250ms ease-in'), style({
          height: 0,
          opacity: 0,
          transform: 'translateX(50%)'
        }))
      ])
    ])
  ]
})
export class ChatAreaComponent implements OnInit {
  room: Room = new Room();
  inputText: string = '';
  subs?: Subscription;
  paramValue: string = '';
  preferenceType = '';
  userStatus: string = '';
  userName: string = '';
  // Typing indicator retired along with the Firestore write it depended on — kept as an always-empty
  // field since the template still binds to it.
  typingStatus: string = '';
  @Input() from: any = '';
  //storage
  selectedFiles: any[] = [];
  finalSelectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  downloadUrlList: any[] = [];
  percentage = 0;
  isLoading: boolean = false;
  disabled: boolean = false;
  displayToolbar: boolean = true;
  editorInitialized: boolean = false;
  private typingStopTimer: any;
  constructor(
    private clientcommunicationService: ClientcommunicationService,
    private messageService: MessageService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.subs = this.clientcommunicationService.pathParam.subscribe(value => {
      this.paramValue = value;
    });
  }

  selectFile(event: any): void {
    // File Preview
    this.finalSelectedFiles = event.target.files;
    for (let index = 0; index < event.target.files.length; index++) {
      const file = event.target.files[index];
      var size = file.size;
      var name = file.name;
      var extension = name.substring(name.lastIndexOf('.') + 1);
      if (size > 5000000) {
        let finalName = name;
        if (name.length > 20) {
          finalName = name.substring(0, 20) + '...' + extension;
        }
        this.showErrorMessage(finalName + ' File should not be more than 5 MB!')
      }
      if (file.type == 'image/jpeg' || file.type == 'image/png') {
        const reader = new FileReader();
        reader.onload = () => {
          file.src = reader.result as string;
          this.selectedFiles.push(file);
        }
        reader.readAsDataURL(file)
      } else {
        this.selectedFiles.push(file);
      }

    }
    if (this.checkLargeFileExist(this.selectedFiles)) {
      this.disabled = true
    } else {
      this.disabled = false
    }
  }

  upload(i: number): void {
    this.showProgressBar()
    if (this.finalSelectedFiles) {
      const file: File | null = this.finalSelectedFiles.item(i);
      if (file) {
        this.currentFileUpload = new FileUpload(file);
        this.uploadToStorage(this.currentFileUpload);
      }
    }

  }

  uploadToStorage(fileUpload: FileUpload): void {
    const businessId = this.room.business_id?.toString() || '';
    this.clientcommunicationService.pushFileToStorage(fileUpload, businessId).subscribe({
      next: (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          this.percentage = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const attachments: { name: string, url: string }[] = event.body?.data || [];
          attachments.forEach(a => this.downloadUrlList.push({ url: a.url, name: a.name }));
          if (this.selectedFiles.length == this.downloadUrlList.length) {
            let thread = this.getPrepareChatMsg()
            thread.attachments = this.downloadUrlList;
            this.saveMessage(thread)
            this.hideProgressBar()
            this.clearFiles()
          }
        }
      },
      error: (error) => {
        console.log(error);
        this.hideProgressBar()
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
      }
    });
  }


  saveFilesToStorage() {
    for (let index = 0; index < this.selectedFiles.length; index++) {
      this.upload(index)
    }
  }

  getPrepareChatMsg() {
    let thread: any = {
      message_channel_type: this.preferenceType == 'chatstasy' ? "chat" : "sms",
      sender_id: '01',
      sender_image: '',
      sender_name: CommonFunctions.getUser().firstName + ' ' + CommonFunctions.getUser().lastName,
      sender_type: "System",
      text: this.inputText.replace(/&amp;/g, '&'),
      attachments: [],
      recepient_id: this.room.business_id?.toString(),
      read_status: 'unread',
      timestamp: new Date()
    }
    return thread
  }

  sendData() {
    this.inputText = CKEDITOR.instances.editor.getData();

    if (this.selectedFiles.length !== 0) {
      this.saveFilesToStorage();
      return;
    }

    const plainCheck = this.inputText.replace(/<[^>]+>/g, '').trim();
    if (plainCheck === '') {
      return;
    }

    const thread = this.getPrepareChatMsg();
    this.saveMessage(thread);
  }

  saveMessage(thread: any): void {
    if (this.selectedFiles.length == 0 && this.preferenceType == 'nonchatstasy') {
      this.sendSMS(thread)
      this.clearData()
    } else if (this.selectedFiles.length != 0 && this.preferenceType == 'nonchatstasy') {
      this.sendSMS(thread)
      this.saveSupportMessage(thread)
    } else {
      this.saveSupportMessage(thread)
    }
  }

  sendSMS(thread: any) {
    const { timestamp, ...newThread } = thread;
    this.clientcommunicationService.sendSMS(newThread, this.paramValue).subscribe(
      (response: any) => {
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessMessage('Message sent successfully.')
        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  saveSupportMessage(thread: any): void {
    this.clientcommunicationService.sendSupportMessageRest(this.paramValue, thread.text, thread.attachments || []).subscribe(
      () => {
        this.clearData();
        if (thread.attachments?.length) {
          this.clearFiles();
        }
      },
      (error: any) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG);
      }
    );
  }

  setUserStatus(rv: any) {
    this.userName = rv.business_name;

    // Init CKEditor once, after *ngIf renders the editor textarea
    if (!this.editorInitialized) {
      setTimeout(() => this.initCKEditor(), 100);
    }
  }

  RoomData(ev: any): void {
    if (ev.RoomData !== undefined) {
      ev.RoomData.subscribe((room: Room) => {
        if (room != undefined) {
          this.room = room
          this.preferenceType = room.preference_type || '';
          this.setUserStatus(room);
        }
      });
    }
    if (ev.TypingChanged !== undefined) {
      ev.TypingChanged.subscribe((isTyping: boolean) => {
        this.typingStatus = isTyping ? 'Typing...' : '';
      });
    }
  }

  /** Emits System Admin's own typing state to the business, debounced so a "stopped typing"
   * event fires automatically ~2s after the last keystroke. */
  onTyping(): void {
    if (!this.paramValue || !this.room?.business_id) {
      return;
    }
    const businessId = this.room.business_id.toString();
    const roomId = this.paramValue;
    this.clientcommunicationService.emitTyping(businessId, roomId, 'System', true);
    clearTimeout(this.typingStopTimer);
    this.typingStopTimer = setTimeout(() => {
      this.clientcommunicationService.emitTyping(businessId, roomId, 'System', false);
    }, 2000);
  }

  private stopTyping(): void {
    clearTimeout(this.typingStopTimer);
    if (this.paramValue && this.room?.business_id) {
      this.clientcommunicationService.emitTyping(this.room.business_id.toString(), this.paramValue, 'System', false);
    }
  }

  clearData() {
    this.messageService.clear('errMsg');
    this.inputText = '';
    CKEDITOR.instances.editor.setData('');
    this.stopTyping();
  }

  clearFiles() {
    this.selectedFiles = []
    this.finalSelectedFiles = undefined;
    this.downloadUrlList = [];
    this.messageService.clear('errMsg');
  }

  removeToFileList(file: any) {
    let index = this.selectedFiles.indexOf(file)
    if (index != -1) {
      this.selectedFiles.splice(index, 1)
    }
    if (this.selectedFiles.length == 0) {
      this.clearFiles()
    }
    if (this.checkLargeFileExist(this.selectedFiles)) {
      this.disabled = true
    } else {
      this.messageService.clear('errMsg');
      this.disabled = false
    }
  }

  checkLargeFileExist(array: any) {
    return array.some((file: any) => {
      return file.size > 5000000;
    });
  }


  initCKEditor() {
    if (this.editorInitialized) return;
    if (CKEDITOR.instances && CKEDITOR.instances['editor']) {
      this.editorInitialized = true;
      return;
    }

    const checkElement = document.getElementById("editor");
    if (!checkElement) return;

    this.editorInitialized = true;

    // Run outside Angular zone so CKEditor's internal timers don't trigger change detection
    this.ngZone.runOutsideAngular(() => {
      CKEDITOR.replace('editor', {
        toolbar: [
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-'] },
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
          { name: 'insert', items: ['Smiley'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: ['Maximize'] },
        ],
        height: "70px",
        removePlugins: 'elementspath,exportpdf',
        resize_enabled: false,
        stylesSet: [
          { name: 'Italic Title', element: 'h2', styles: { 'font-style': 'italic' } },
          { name: 'Subtitle', element: 'h3', styles: { 'color': '#aaa', 'font-style': 'italic' } },
          { name: 'Special Container', element: 'div', styles: { 'padding': '5px 10px', 'background': '#eee', 'border': '1px solid #ccc' } },
          { name: 'Bold', element: 'strong' },
          { name: 'Italic', element: 'em' },
          { name: 'Underline', element: 'u' },
          { name: 'Strike', element: 'strike' },
          { name: 'Big', element: 'big' },
          { name: 'Small', element: 'small' },
          { name: 'Sample Text', element: 'samp' }
        ],
        format_tags: 'p;h1;h2;h3;h4;h5;h6',
        on: {
          key: () => {
            this.onTyping();
          },
        },
      });

      // Hide the toolbar by default
      let checkId = setInterval(() => {
        var toolbar: any = document.getElementsByClassName("cke_reset_all");
        if (toolbar[0] != null) {
          clearInterval(checkId);
          toolbar[0].style.display = "none";
        }
      }, 100);
    });
  }

  showToolBar() {
    if (this.displayToolbar) {
      var toolbar: any = document.getElementsByClassName("cke_reset_all");
      toolbar[0].style.display = "block";
    } else {
      var toolbar: any = document.getElementsByClassName("cke_reset_all");
      toolbar[0].style.display = "none";
    }
    this.displayToolbar = !this.displayToolbar;
  }

  ngOnDestroy() {
    // Destroy the CKEditor instance so it can be cleanly re-created on next init
    if (CKEDITOR.instances && CKEDITOR.instances['editor']) {
      CKEDITOR.instances['editor'].destroy();
    }
    this.editorInitialized = false;
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  showErrorToastMsg(msg: string) {
    this.messageService.clear('br');
    this.messageService.add({
      key: 'br',
      severity: 'error',
      detail: msg,
    });
  }

  showSuccessMessage(msg: string) {
    this.messageService.clear('br');
    this.messageService.add({
      key: 'br',
      severity: 'success',
      detail: msg,
    });
  }

  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }


  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }

  showProgressBar() {
    this.messageService.clear('errMsg');
    this.isLoading = true;
    this.disabled = true;
  }

}
